import { PROMO_COMPANIES_IDS } from "../constants";

export const isPromoEnabledForCompanyId = (companyId: number) => {
    return PROMO_COMPANIES_IDS.includes(companyId);
}